module.exports = __webpack_public_path__ + "img/stand_boluo_1.d875517b.jpg";